export default __webpack_public_path__ + "static/media/g-1.3956f280.jpg";